<script lang="typescript">
  import type { Day } from "./customer-calendar-types";

  export let day:Day;
  $: hoverTitle = day.meetings.map(m=>m.title).join("\n");
</script>

<div  
     class="week-day" 
     class:available={day.is_available}
     class:current-day={day.is_current_day} 
     title="{hoverTitle}">
     <h2 class="formatted">
       {day.formatted}
     </h2>
     <h2 class="day-only">
       {day.day_number}
     </h2>
     <div class="meetings">
     {#each day.meetings as meeting}
       <p class="meeting">{meeting.title}</p>
     {/each}
     </div>
</div>

<style>

  .week-day {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  .week-day.available {
    cursor: pointer;
  }

  .meetings {
    flex-grow: 1;
  }

  .meeting {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  @media screen and (max-width: 480px) {
    .week-day {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .meetings {
      display: none;
    }
  }

</style>

